var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "merged-page" }, [
    _c(
      "div",
      { staticClass: "route-page-content" },
      [
        _c("ChatbotMenu", {
          model: {
            value: _vm.selectedTab,
            callback: function ($$v) {
              _vm.selectedTab = $$v
            },
            expression: "selectedTab",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-content-wrapper" },
          [
            _vm.isSelected("archive") ? _c("ChatbotArchive") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("entities") ? _c("Entities") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("training") ? _c("Training") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("user-segments") ? _c("UserSegments") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("stories") ? _c("StoryList") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("templates") ? _c("Templates") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("ai/templates") ? _c("AITemplates") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("integrations") ? _c("Integrations") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("reports/all-chats") ? _c("AllChats") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("reports/overall") ? _c("Overall") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("reports/busiest-period")
              ? _c("BusiestPeriod")
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("reports/rating-distribution")
              ? _c("RatingDistribution")
              : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("reports/popularity") ? _c("Popularity") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("block-market") ? _c("BlockMarket") : _vm._e(),
            _vm._v(" "),
            _vm.isSelected("sandbox") ? _c("ChatbotSandbox") : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }